import React from 'react'

import { usePageContentPadding } from '@/hooks/usePageContentPadding'
import { cn } from '@/lib/utils'

type Props = React.HTMLAttributes<HTMLDivElement> & {
  children?: React.ReactNode
  padded?: boolean
}

const PageContent: React.FC<Props> = ({
  children,
  className,
  padded = true,
  style = {},
  ...props
}) => {
  const padding = usePageContentPadding()

  return (
    <div
      {...props}
      className={cn('flex-1', className)}
      css={{
        padding: padded ? padding.xAndY : undefined,
        '.SentryErrorBoundary': padded
          ? undefined
          : {
              marginTop: '40px',
              marginLeft: '30px',
            },
        ...style,
      }}
    >
      {children}
    </div>
  )
}

export default PageContent
